import { useEffect, useRef } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import useNavigateNext from "../../common/components/useNavigateNext"
import { useAuth } from "../AutoContextProvider"

const Auth = (props) => {
  const [_, {sso, getCookie, getFinalGuestToken}]= useAuth()
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, navigateNext] = useNavigateNext(location)
    const abort = new AbortController()
    const searchUrlParams = new URLSearchParams(location.search);

    useEffect(() => {
      const tokenParam = searchParams.get('token')
      const refreshParam = searchParams.get('refresh')
      const userType = searchUrlParams.get('userType')
    
      const performSso = async () => {
        if (tokenParam) {
          const getFinalToken = await getFinalGuestToken(refreshParam)
          const ssoData = await sso(getFinalToken?.token, getFinalToken?.refresh_token);
          if (ssoData) {
            navigateNext(`/TypeForm?user_type=guest&from_location=webflow`);
          } else {
            location.googleSignIn = true;
            navigateNext('/TypeForm?user_type=guest&from_location=webflow');
          }
        } else {
          const token = getCookie('tkn-ath')
          const refresh = getCookie('tkn-ath-rfrsh')
          const role = getCookie('tkn-ath-role')
          if (token) {
            try {
              const getSso = await sso(token, refresh,role);
              if(getSso) {
                navigateNext(`/TypeForm?user_type=guest&from_location=webflow`)
              }else{
                navigateNext('/TypeForm?user_type=guest&from_location=webflow')
              }
            } catch (err) {
              navigateNext('/TypeForm?user_type=guest&from_location=webflow');
            }
          } else {
            const nextUrl = location.pathname;
            navigateNext("/TypeForm?user_type=guest&from_location=webflow", {
              next: nextUrl === "/" ? `/TypeForm?user_type=guest&from_location=webflow` : nextUrl,
            });

          }
        }
      };
    
      performSso();
    
      return () => {
        abort.abort();
      };
    }, []);
    
    return  null;
}

export default Auth